












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GradeClassCount } from '@/models/student/check-student-differences-result';

// クラス名の比較。「東郷2組」と「東郷10組」を数値順に並べるため numeric を有効にする
const compareClassName = (a: GradeClassCount, b: GradeClassCount): number =>
  (a.schoolClassName || '').localeCompare(b.schoolClassName || '', 'ja', { numeric: true });

@Component({ name: 'GStudentImportUploadConfirm' })
export default class GStudentImportUploadConfirm extends Vue {
  gradeChecked: { [grade: number]: boolean } = {};

  @Prop({ default: '' }) fileName: string;
  @Prop({ default: (): GradeClassCount[] => [] }) data: GradeClassCount[];

  @Watch('grades', { immediate: true })
  onGradesChange(grades: number[]) {
    grades.forEach(g => {
      if (this.gradeChecked[g] === undefined) {
        this.$set(this.gradeChecked, g, false);
      }
    });
  }

  get grades(): number[] {
    const set = new Set<number>((this.data || []).map(r => r.grade));
    return Array.from(set).sort((a, b) => a - b);
  }

  // 学年ごとのクラス行。APIの配列順はサーバ側のmap反復順に依存して非決定的なため、
  // クラス名でソートして表示順を安定させる（computedなのでdata変更時のみ再計算される）
  get sortedRowsByGrade(): { [grade: number]: GradeClassCount[] } {
    const map: { [grade: number]: GradeClassCount[] } = {};
    (this.data || []).forEach(r => {
      if (!map[r.grade]) {
        map[r.grade] = [];
      }
      map[r.grade].push(r);
    });
    Object.keys(map).forEach(grade => map[Number(grade)].sort(compareClassName));
    return map;
  }

  rowsByGrade(grade: number): GradeClassCount[] {
    return this.sortedRowsByGrade[grade] || [];
  }

  gradeTotalCount(grade: number): number {
    return this.rowsByGrade(grade).reduce((s, r) => s + r.totalCount, 0);
  }

  gradeTotalNew(grade: number): number {
    return this.rowsByGrade(grade).reduce((s, r) => s + r.newCount, 0);
  }

  gradeTotalExisting(grade: number): number {
    return this.rowsByGrade(grade).reduce((s, r) => s + r.existingCount, 0);
  }

  get allGradesChecked(): boolean {
    return this.grades.length > 0 && this.grades.every(g => !!this.gradeChecked[g]);
  }

  emitCheckedChange() {
    this.$emit('checkedChange', this.allGradesChecked);
  }

  onClickTotal(grade: number, schoolClassName: string | null) {
    this.$emit('showStudentList', { grade, schoolClassName });
  }
}
